import LoginPage from './LoginConnector';

export default LoginPage;
